<div
    class="input-wrapper"
    [tcTooltip]="inputTooltipText"
    [placement]="inputTooltipPlacement"
    [ngClass]="{ error: !isValid, isSmall: inputIsSmall }"
>
    <input
        id="{{ _id }}"
        [type]="inputIsPassword ? 'password' : 'text'"
        [(ngModel)]="value"
        name="{{ inputName }}"
        (blur)="_onCustomBlur(value)"
        (input)="onInput()"
        autocomplete="off"
        [disabled]="isDisabled"
        [ngClass]="{ isSmall: inputIsSmall, isEmpty: !_innerValue && _innerValue !== 0 }"
        pattern="{{ regex }}"
        maxlength="{{ inputMaxLength }}"
        minlength="{{ inputMinLength }}"
        [readonly]="inputIsReadonly"
        placeholder="{{ inputIsRequired ? inputName + '*' : inputName }}"
        required
    />
    <label
        [tcTooltip]="inputName"
        tabindex="-1"
        [onlyEllipsisTooltip]="true"
        *ngIf="(_innerValue || _innerValue === 0) && inputName"
        htmlFor="{{ _id }}"
        >{{ inputName }}
        <span *ngIf="inputIsRequired">*</span>
    </label>
</div>
